import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(modalOpenSagaWorker),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(modalOpenSagaWatcher),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(modalCloseSagaWorker),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(modalCloseSagaWatcher),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(modalCloseAllSagaWorker),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(modalCloseAllSagaWatcher),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(modalCloseWithAnswerSagaWorker),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(modalCloseWithAnswerSagaWatcher),
    _marked9 = /*#__PURE__*/_regeneratorRuntime.mark(modalsSaga);

import { all, fork, put, takeLatest } from 'redux-saga/effects';
import { ConstantsUtil } from '@utils';
import { INIT_CLOSE_ALL_MODALS, INIT_CLOSE_MODAL, INIT_MODAL_CLOSING_WITH_ANSWER, MODAL_INIT } from './modals.action-types';
import { actions } from './modals.actions';

/**
 * Open modal saga worker.
 *
 * @author Ihar Kazlouski
 * @function modalOpenSagaWorker
 * @category Sagas
 * @subcategory Modals
 * @return {Generator<PutEffect>} action data.
 */
function modalOpenSagaWorker(action) {
  return _regeneratorRuntime.wrap(function modalOpenSagaWorker$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(actions.setModal({
            modalId: action.payload.modalId,
            isOpen: action.payload.isOpen,
            data: action.payload.data
          }));

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
/**
 * Set new modal to saga watcher.
 *
 * @author Ihar Kazlouski
 * @function modalOpenSagaWatcher
 * @category Sagas
 * @subcategory Modals
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function modalOpenSagaWatcher() {
  return _regeneratorRuntime.wrap(function modalOpenSagaWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return all([takeLatest(MODAL_INIT, modalOpenSagaWorker)]);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
/**
 * Close modal saga worker.
 *
 * @author Ihar Kazlouski
 * @function modalCloseSagaWorker
 * @category Sagas
 * @subcategory Modals
 * @return {Generator<PutEffect>} action data.
 */


function modalCloseSagaWorker(action) {
  return _regeneratorRuntime.wrap(function modalCloseSagaWorker$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return put(actions.modalClose({
            modalId: action.payload.modalId
          }));

        case 2:
          _context3.next = 4;
          return put({
            type: "".concat(MODAL_INIT, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS),
            payload: {
              modalId: action.payload.modalId
            }
          });

        case 4:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
/**
 * Close modal.
 *
 * @author Ihar Kazlouski
 * @function modalCloseSagaWatcher
 * @category Sagas
 * @subcategory Modals
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function modalCloseSagaWatcher() {
  return _regeneratorRuntime.wrap(function modalCloseSagaWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return all([takeLatest(INIT_CLOSE_MODAL, modalCloseSagaWorker)]);

        case 2:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
/**
 * Close modal all saga worker.
 *
 * @author Ihar Kazlouski
 * @function modalCloseSagaWorker
 * @category Sagas
 * @subcategory Modals
 * @return {Generator<PutEffect>} action data.
 */


function modalCloseAllSagaWorker() {
  return _regeneratorRuntime.wrap(function modalCloseAllSagaWorker$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return put(actions.modalCloseAll());

        case 2:
          _context5.next = 4;
          return put({
            type: "".concat(INIT_CLOSE_ALL_MODALS, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS)
          });

        case 4:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}
/**
 * Close modal.
 *
 * @author Ihar Kazlouski
 * @function modalCloseSagaWatcher
 * @category Sagas
 * @subcategory Modals
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function modalCloseAllSagaWatcher() {
  return _regeneratorRuntime.wrap(function modalCloseAllSagaWatcher$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return all([takeLatest(INIT_CLOSE_ALL_MODALS, modalCloseAllSagaWorker)]);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}
/**
 * Close modal with answer saga worker.
 *
 * @author Ihar Kazlouski
 * @function modalCloseWithAnswerSagaWorker
 * @category Sagas
 * @subcategory Modals
 * @return {Generator<PutEffect>} action data.
 */


function modalCloseWithAnswerSagaWorker(action) {
  return _regeneratorRuntime.wrap(function modalCloseWithAnswerSagaWorker$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return put(actions.closeWithAnswer({
            modalId: action.payload.modalId,
            accepted: action.payload.accepted,
            rejected: action.payload.rejected
          }));

        case 2:
          if (!action.payload.accepted) {
            _context7.next = 7;
            break;
          }

          _context7.next = 5;
          return put({
            type: "".concat(MODAL_INIT, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS),
            payload: {
              modalId: action.payload.modalId,
              accepted: action.payload.accepted,
              rejected: action.payload.rejected
            }
          });

        case 5:
          _context7.next = 9;
          break;

        case 7:
          _context7.next = 9;
          return put({
            type: "".concat(MODAL_INIT, "/").concat(ConstantsUtil.actions.ASYNC_FAILED),
            error: {
              modalId: action.payload.modalId,
              accepted: action.payload.accepted,
              rejected: action.payload.rejected
            }
          });

        case 9:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}
/**
 * Close modal with answer.
 *
 * @author Ihar Kazlouski
 * @function modalCloseWithAnswerSagaWatcher
 * @category Sagas
 * @subcategory Modals
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


function modalCloseWithAnswerSagaWatcher() {
  return _regeneratorRuntime.wrap(function modalCloseWithAnswerSagaWatcher$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return all([takeLatest(INIT_MODAL_CLOSING_WITH_ANSWER, modalCloseWithAnswerSagaWorker)]);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}
/**
 * Modals saga.
 *
 * @author Ihar Kazlouski
 * @function modalsSaga
 * @category Sagas
 * @subcategory Modals
 * @return {Generator<AllEffect<ForkEffect>>} data.
 */


export default function modalsSaga() {
  return _regeneratorRuntime.wrap(function modalsSaga$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return all([fork(modalOpenSagaWatcher), fork(modalCloseSagaWatcher), fork(modalCloseWithAnswerSagaWatcher), fork(modalCloseAllSagaWatcher)]);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}